import React from 'react';
import {connect} from 'react-redux';
import {
  loginUserAsync,
  loginAboradMagicLinkUserAsync,
  loginOrgEmployeeAsync,
  clearError,
  saveLoginData,
} from '../../../utilities/authentication/authenticationSlice';
import helper from '../../../utilities/helper';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {saveLoginCookie} from '../../../utilities/cookieUtils';
import Config from '../../../Config';
import {connectTokenAndRedirect} from '../../Block/EcommerceOtpBlock/ecommerceOtpSlice';
import './kmsi.scss';
import authentication from 'app/middleware/authentication';

class Kmsi extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  
  async componentDidMount() {
    this.props.clearError();
    this.props.showAppLoader();

    let loginType = helper.getUrlParameter('LoginType').toUpperCase();
    let tempToken = helper.getUrlParameter('code');

    if (loginType === 'SILENTLOGINOTP') {
      await this.props.loginAboradMagicLinkUserAsync({
        tempToken,
        context: this.props.context,
      });
    }
     else if(localStorage.getItem("isOrgEmployeeLogin") == "true" && tempToken !== ''){
         var result = await this.props.loginOrgEmployeeAsync({
          tempToken,
          context: this.props.context,
        });

        var storage = window.localStorage || window.sessionStorage;
        this.props.hideAppLoader();
        storage.setItem('urlVariables', JSON.stringify(result.payload));
        storage.setItem('previousPage', 'loginSuccess');
        var pageData = {eventType: 'returnFromLogin', status: 'orgEmployeeFamily'};
        parent.postMessage(pageData, '*');
        let returnUrl = helper.getUrlParameter('returnUrl');
        if (returnUrl.indexOf('?') != -1) {
          returnUrl = returnUrl.split('?')[0];
        }
        var fullUrl = Config.staticWebSiteUrl + returnUrl.toLowerCase();
        window.location.replace(fullUrl);
    }
     else {
        await this.props.loginUserAsync({
          tempToken,
          context: this.props.context,
        });
        let actionType = helper.getUrlParameter('loginType').toUpperCase();
        console.log(`[kmsi] actionType: ${actionType ? actionType : 'null'}`);
        if (actionType === 'COMPLETEREGISTRATION') {
          let contactNumber = this.props.loginData?.userDetails?.contactNumber;
          let returnUrl = helper.getUrlParameter('returnUrl');

          this.props.connectTokenAndRedirect({
            contactValue: contactNumber,
            loginType: 'CREDENTIALS',
            returnUrl: returnUrl,
          });
        }
      
    }
  }

  async shouldComponentUpdate(nextProps) {


    if (nextProps.loginData && this.props.loginData != nextProps.loginData) {
      let tempToken = helper.getUrlParameter('code');
      let returnUrl = helper.getUrlParameter('returnUrl');
      let loginLite = helper.getUrlParameter('loginLite');
      // let loginType = helper.getUrlParameter('login_type');
      let actionType = helper.getUrlParameter('loginType').toUpperCase();

      // remove parameters from target
      if (returnUrl.indexOf('?') != -1) {
        returnUrl = returnUrl.split('?')[0];
      }

      if (tempToken !== '') {
        saveLoginCookie(nextProps.loginData);
      }

      this.props.hideAppLoader();

      // store parameters in storage
      var storage = window.localStorage || window.sessionStorage;
      storage.setItem('previousPage', 'loginSuccess');
      let urlVariables = helper.getUrlVariables();
      storage.setItem('urlVariables', JSON.stringify(urlVariables));
 
      const status =  urlVariables.newcustomer == '1' ? 'newCustomer' : 'loginSuccess';
      var pageData = {eventType: 'returnFromLogin', status: status};

      if (loginLite == 'true' || returnUrl === '/idf-login') {
        parent.postMessage(pageData, '*');
      } else if (nextProps.loginData.userDetails.loginSubType === 'PRIVATE_IDF') {
        parent.postMessage(pageData, '*');
      } else {
        if (actionType !== 'COMPLETEREGISTRATION') {
          // redirect to clean page with parameters
          console.log(`%c [kmsi] Reload to ${returnUrl}`, 'background: #222; color:rgb(244, 14, 26)');
          console.log(`********************* RELOAD ***************************`);
          var fullUrl = Config.staticWebSiteUrl + returnUrl.toLowerCase();
          window.location.replace(fullUrl);
        }
      }
    }
  }

  render() {
    return (
      <div className='kmsi-page' style={{minHeight: '100vh'}}>
        <div></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginData: state.authentication.loginData,
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  loginUserAsync,
  loginAboradMagicLinkUserAsync,
  showAppLoader,
  hideAppLoader,
  clearError,
  saveLoginData,
  connectTokenAndRedirect,
  loginOrgEmployeeAsync,

};

export default connect(mapStateToProps, mapDispatchToProps)(Kmsi);
